import React, { useEffect, useState } from "react";
import { GridFilterListIcon } from "@mui/x-data-grid";

import CustomButton from "../../components/common/Button";
import MuiFilterButton from "../../components/common/FilterButton/MuiFilterButton";
import NewSearch from "../../components/common/Search/new-search";
import { useDebounce } from "../../hooks/useDebounce";
import { useParams } from "react-router-dom";
import { GET_ORDER } from "../../api/queries/Queries";
import { useLazyQuery } from "@apollo/client";
import { stagingOptions, wmsOptions } from "../../constants/apollo";
import OrderMap from "./components/OrderMap";
import moment from "moment";
import { getBackgroundColors } from "../../components/colors";

export default function OrderDetails() {
  const [searchText, setSearchText] = useState("");
  const [showMap, setShowMap] = useState(true);

  const [mapLoading, setMapLoading] = useState(true);

  const { order: trackingNo } = useParams();

  const [data, setData] = useState<any>({});
  const [activeMenu, setActiveMenu] = useState("customer");

  const [getOrder] = useLazyQuery(GET_ORDER, stagingOptions);

  function fetchData(tracking = trackingNo) {
    getOrder({
      variables: {
        trackingNo: tracking,
      },
    }).then((res) => {
      const data = res.data.fetchOrder;
      setData(data);
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="color-black  w-full bg-gray-50 h-full flex flex-col">
      {/* <OrderDeta/> */}
      <div className="flex w-full justify-between space-x-3 p-4 mt-1 bg-white">
        <div className="flex space-x-3">
          <div className="items-center py-1">
            <div
              className={`capitalize ${getBackgroundColors(data.orderStatus)}
               items-center px-2 py-1 rounded-md w-auto text-white text-center`}
            >
              <span>{data?.orderStatus?.replaceAll("_", " ")}</span>
            </div>
          </div>
          <div className="flex flex-col">
            <span className="text-sm text-gray-500">
              Created at {moment(data?.createdAt).format("DD/MM/Y HH:SS")}
            </span>
            <span className="text-sm text-gray-500">Order ID: {data?.id}</span>
          </div>
        </div>
        <div className="flex space-x-3">
          <div className="flex">
            <CustomButton
              variant="outlined"
              color="warning"
              onClick={() => {}}
              style={{ border: "none" }}
            >
              <div className="flex items-center justify-center space-x-2">
                <svg
                  width="17"
                  height="14"
                  viewBox="0 0 17 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.75 0.25C6.0225 0.25 3 3.2725 3 7H0.75L3.6675 9.9175L3.72 10.0225L6.75 7H4.5C4.5 4.0975 6.8475 1.75 9.75 1.75C12.6525 1.75 15 4.0975 15 7C15 9.9025 12.6525 12.25 9.75 12.25C8.3025 12.25 6.99 11.6575 6.045 10.705L4.98 11.77C6.2025 12.9925 7.8825 13.75 9.75 13.75C13.4775 13.75 16.5 10.7275 16.5 7C16.5 3.2725 13.4775 0.25 9.75 0.25ZM9 4V7.75L12.21 9.655L12.75 8.7475L10.125 7.1875V4H9Z"
                    fill="#FF9800"
                  />
                </svg>
                <span className="uppercase text-warningColor">
                  Order history
                </span>
              </div>
            </CustomButton>
          </div>
          <div className="flex">
            <CustomButton
              variant="outlined"
              color="warning"
              onClick={() => {}}
              style={{ border: "none" }}
            >
              <div className="flex items-center justify-center space-x-2">
                <svg
                  width="17"
                  height="14"
                  viewBox="0 0 17 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.75 0.25C6.0225 0.25 3 3.2725 3 7H0.75L3.6675 9.9175L3.72 10.0225L6.75 7H4.5C4.5 4.0975 6.8475 1.75 9.75 1.75C12.6525 1.75 15 4.0975 15 7C15 9.9025 12.6525 12.25 9.75 12.25C8.3025 12.25 6.99 11.6575 6.045 10.705L4.98 11.77C6.2025 12.9925 7.8825 13.75 9.75 13.75C13.4775 13.75 16.5 10.7275 16.5 7C16.5 3.2725 13.4775 0.25 9.75 0.25ZM9 4V7.75L12.21 9.655L12.75 8.7475L10.125 7.1875V4H9Z"
                    fill="#FF9800"
                  />
                </svg>
                <span className="uppercase text-warningColor">
                  Courier’s action
                </span>
              </div>
            </CustomButton>
          </div>
          <MuiFilterButton
            variant="outlined"
            options={["Export List", "Operations", "Rebase and merge"]}
          />
          <MuiFilterButton
            options={["Export List", "Export List", "Rebase and merge"]}
          />
        </div>
      </div>

      <div className="flex w-full space-x-4 bg-gray-50 p-3">
        <div className="w-3/4 bg-white p-4 rounded-md">
          <div className="flex justify-between">
            <div className="text-xl">Order Details</div>
            <div className="flex space-x-3">
              <div className="bg-warningColor px-2 rounded-md w-auto text-white">
                Shipment: {data?.shipment?.id || "N/A"}
              </div>
              <div className="bg-successColor px-2 rounded-md w-auto text-white ">
                Notified by{" "}
                <span className="capitalize">{data?.notifiedBy}</span>
              </div>
            </div>
          </div>
          <div className="flex w-full mt-5">
            <div className="w-1/5 flex flex-col space-y-4">
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm ">Order type</span>
                <span className="capitalize">
                  {data?.orderType ? data.orderType.replace("_", " ") : "-"}
                </span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Distance</span>
                <span className="">{data?.drivingDistance || 0} km</span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Duration</span>
                <span className="">{data?.drivingDuration || 0} min</span>
              </div>
            </div>
            <div className="w-1/5 flex flex-col space-y-4">
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Shipment Id</span>
                <span className="text-warningColor">
                  {data?.shipment?.id || "N/A"}
                </span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Delivery OTP</span>
                <span className="">{data?.deliveryOtp || "-"}</span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">COD Fee</span>
                <span className="">{data?.codFee || "0"} SAR</span>
              </div>
            </div>
            <div className="w-1/5 flex flex-col space-y-4">
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Neighborhood</span>
                <span className="text-warningColor">
                  {data?.neighborhood || "-"}
                </span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Pickup OTP</span>
                <span className="r">{data?.pickupOtp || "-"}</span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm ">Payment Status</span>
                <span className="capitalize">
                  {data?.paymentStatus
                    ? data?.paymentStatus.replace("_", " ")
                    : "-"}
                </span>
              </div>
            </div>
            <div className="w-1/5 flex flex-col space-y-4">
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Order Cost</span>
                <span className="r">{data?.orderCost || 0}</span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Return OTP</span>
                <span className="r">{data?.returnOtp}</span>
              </div>
              {/* <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">
                  Invoice Payment Status
                </span>
                <span className="">Not an on-demand order</span>
              </div> */}
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm"></span>
                <span className=""></span>
              </div>
            </div>
            <div className="w-1/5 flex flex-col space-y-4">
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Delivery Fee</span>
                <span className="flex items-center space-x-3">
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.3335 0.666504H1.66683C0.926829 0.666504 0.340163 1.25984 0.340163 1.99984L0.333496 9.99984C0.333496 10.7398 0.926829 11.3332 1.66683 11.3332H12.3335C13.0735 11.3332 13.6668 10.7398 13.6668 9.99984V1.99984C13.6668 1.25984 13.0735 0.666504 12.3335 0.666504ZM12.3335 9.99984H1.66683V5.99984H12.3335V9.99984ZM12.3335 3.33317H1.66683V1.99984H12.3335V3.33317Z"
                      fill="black"
                      fillOpacity="0.54"
                    />
                  </svg>
                  <span>{data?.deliveryFee || "0"} SAR</span>
                </span>
              </div>

              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm">Address Status</span>
                <span className="text-successColor capitalize">
                  {data?.addressStatus
                    ? data.addressStatus.replace("_", " ")
                    : "-"}
                </span>
              </div>
              <div className="flex flex-col h-16">
                <span className="text-lightColor text-sm"></span>
                <span className=""></span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white w-1/4 rounded-md">
          <div className="text-center flex">
            <div
              onClick={() => setActiveMenu("customer")}
              className={`w-1/2 p-4 border-b-2 cursor-pointer ${
                activeMenu === "customer" && "border-warningColor"
              } text-warningColor`}
            >
              CUSTOMER
            </div>

            <div
              onClick={() => setActiveMenu("orderItems")}
              className={`w-1/2 p-4 border-b-2 cursor-pointer ${
                activeMenu === "orderItems" && "border-warningColor"
              } `}
            >
              ORDER ITEMS
            </div>
          </div>
          {activeMenu === "customer" && (
            <div className="flex flex-col p-4 space-y-3">
              <div className="flex space-x-1">
                <span className="text-lightColor">Name:</span>
                <span className="font-bold">Jane Miracles</span>
              </div>
              <div className="flex space-x-1">
                <span className="text-lightColor">Customer Total Orders:</span>
                <span className="font-bold">12</span>
              </div>
              <div className="flex space-x-1">
                <span className="text-lightColor">Phone Number:</span>
                <span className="font-bold">+99890 987 65 43</span>
              </div>
              <div className="flex space-x-1">
                <span className="text-lightColor">Address:</span>
                <span className="font-bold">1, Somestr st., Anydist dist.</span>
              </div>
            </div>
          )}
          <div className="w-full flex items-center justify-center p-4">
            <CustomButton variant="outlined" color="warning" onClick={() => {}}>
              <div className="flex items-center justify-center space-x-3">
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 5H3C1.34 5 0 6.34 0 8V14H4V18H16V14H20V8C20 6.34 18.66 5 17 5ZM14 16H6V11H14V16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM16 0H4V4H16V0Z"
                    fill="#FF9800"
                  />
                </svg>
                <span>Print</span>
              </div>
            </CustomButton>
          </div>
        </div>
      </div>

      <div
        className={`flex w-full space-x-2 p-3 pt-3 bg-white m-3 ${
          !data?.shipment && "invisible"
        }`}
      >
        <div className="w-2/5 h-full ">
          <OrderMap
            data={data}
          />
        </div>
        <div className="flex flex-col w-full bg-white">
          <div className="p-2 flex flex-col space-y-2  w-full">
            <div className="text-xl">Location Info</div>
            <div className="flex w-full space-x-3">
              <div className="w-1/4">
                <div className="flex flex-col">
                  <span className="text-lightColor text-sm">Delivery NBHD</span>
                  <span className="text-warningColor">
                    {data?.neighborhood || "-"}
                  </span>
                </div>
              </div>
              <div className="w-1/4">
                <div className="flex flex-col">
                  <span className="text-lightColor text-sm">
                    Address / Region
                  </span>
                  <span>{data?.address?.fullAddress || "-"}</span>
                </div>
              </div>
              <div className="w-1/4">
                <div className="flex flex-col">
                  <span className="text-lightColor text-sm">Delivery City</span>
                  <span>{data?.hub?.city || "-"}</span>
                </div>
              </div>
              <div className="w-1/4">
                <div className="flex flex-col">
                  <span className="text-lightColor text-sm">Pickup Hub</span>
                  <span>{data?.hub?.code || "-"}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full bg-gray-200 h-[1px] my-5"></div>

          <div className="p-2 flex flex-col space-y-2  w-fulls">
            <div className="text-xl">Driver Info</div>
            <div className="flex w-full">
              <div className="w-1/4 flex space-x-3">
                <div className="flex flex-col justify-between h-full items-center">
                  <div className="w-10 h-10 flex items-center justify-center">
                    {data?.shipment?.courier?.avatarUrl ? (
                      <img
                        className="h-4 w-4 mr-1 rounded-full border border-transparent bg-white"
                        src={data.shipment.courier.avatarUrl}
                      />
                    ) : (
                      <img
                        className="h-10 w-10 rounded-full border border-transparent bg-white"
                        src="../images/avatar.png"
                      />
                    )}
                  </div>
                  {data?.shipment?.courier && (
                    <div className="bg-successColor text-white rounded-md px-2">
                      {data.shipment.courier.isOnline ? "Online" : "Offline"}
                    </div>
                  )}
                </div>
                {data?.shipment?.courier && (
                  <div className="flex flex-col">
                    <span className="text-lightColor text-sm">Name</span>
                    <span className="text-warningColor">
                      {data?.shipment?.courier?.firstName || "N/A"}{" "}
                    </span>
                    <div className="flex space-x-2 p-2">
                      <svg
                        width="12"
                        height="16"
                        viewBox="0 0 12 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 0.666504L0 3.33317V7.33317C0 11.0332 2.56 14.4932 6 15.3332C9.44 14.4932 12 11.0332 12 7.33317V3.33317L6 0.666504ZM4.66667 11.3332L2 8.6665L2.94 7.7265L4.66667 9.4465L9.06 5.05317L10 5.99984L4.66667 11.3332Z"
                          fill="#4CAF50"
                        />
                      </svg>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.00016 0.333496C3.32016 0.333496 0.333496 3.32016 0.333496 7.00016C0.333496 10.6802 3.32016 13.6668 7.00016 13.6668C10.6802 13.6668 13.6668 10.6802 13.6668 7.00016C13.6668 3.32016 10.6802 0.333496 7.00016 0.333496ZM1.66683 7.00016C1.66683 4.0535 4.0535 1.66683 7.00016 1.66683C8.2335 1.66683 9.36683 2.08683 10.2668 2.7935L2.7935 10.2668C2.08683 9.36683 1.66683 8.2335 1.66683 7.00016ZM7.00016 12.3335C5.76683 12.3335 4.6335 11.9135 3.7335 11.2068L11.2068 3.7335C11.9135 4.6335 12.3335 5.76683 12.3335 7.00016C12.3335 9.94683 9.94683 12.3335 7.00016 12.3335Z"
                          fill="#F44336"
                        />
                      </svg>
                    </div>
                  </div>
                )}
                <div className="flex flex-col">
                  <span className="text-lightColor text-sm">Courier ID</span>
                  <span>{data?.shipment?.courier?.id || "-"}</span>
                </div>
              </div>
              <div className="w-1/4">
                <div className="flex flex-col">
                  <span className="text-lightColor text-sm">Mobile</span>
                  <span>{data?.shipment?.courier?.mobileNumber || "-"}</span>
                </div>
              </div>
              <div className="w-1/4">
                <div className="flex">
                  <span className="text-lightColor text-sm">
                    <svg
                      width="35"
                      height="40"
                      viewBox="0 0 35 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 10H4C2.9 10 2 10.9 2 12V30L6 26H20C21.1 26 22 25.1 22 24V12C22 10.9 21.1 10 20 10ZM20 24H6L4 26V12H20V24Z"
                        fill="black"
                        fillOpacity="0.38"
                      />
                      <rect
                        x="16"
                        width="19"
                        height="20"
                        rx="9.5"
                        fill="#FF9800"
                      />
                      <path
                        d="M24.2168 10.0332L23.0918 9.75781L23.5547 5.46875H28.1543V6.66406H24.7266L24.4922 8.75586C24.625 8.67773 24.8086 8.60156 25.043 8.52734C25.2773 8.44922 25.5449 8.41016 25.8457 8.41016C26.248 8.41016 26.6074 8.47656 26.9238 8.60938C27.2441 8.73828 27.5156 8.92773 27.7383 9.17773C27.9609 9.42383 28.1309 9.72461 28.248 10.0801C28.3652 10.4316 28.4238 10.8281 28.4238 11.2695C28.4238 11.6641 28.3652 12.0332 28.248 12.377C28.1348 12.7207 27.9629 13.0234 27.7324 13.2852C27.502 13.5469 27.2109 13.752 26.8594 13.9004C26.5117 14.0449 26.0996 14.1172 25.623 14.1172C25.2676 14.1172 24.9258 14.0664 24.5977 13.9648C24.2734 13.8594 23.9824 13.7051 23.7246 13.502C23.4668 13.2949 23.2598 13.041 23.1035 12.7402C22.9473 12.4355 22.8574 12.0859 22.834 11.6914H24.2168C24.252 11.9688 24.3281 12.2051 24.4453 12.4004C24.5664 12.5918 24.7266 12.7383 24.9258 12.8398C25.125 12.9414 25.3555 12.9922 25.6172 12.9922C25.8555 12.9922 26.0605 12.9512 26.2324 12.8691C26.4043 12.7832 26.5469 12.6621 26.6602 12.5059C26.7773 12.3457 26.8633 12.1582 26.918 11.9434C26.9766 11.7285 27.0059 11.4902 27.0059 11.2285C27.0059 10.9785 26.9727 10.75 26.9062 10.543C26.8438 10.3359 26.748 10.1562 26.6191 10.0039C26.4941 9.85156 26.3359 9.73438 26.1445 9.65234C25.9531 9.56641 25.7324 9.52344 25.4824 9.52344C25.1465 9.52344 24.8887 9.57227 24.709 9.66992C24.5332 9.76758 24.3691 9.88867 24.2168 10.0332Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span>
                    <svg
                      width="35"
                      height="40"
                      viewBox="0 0 35 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 12H4C2.9 12 2.01 12.9 2.01 14L2 26C2 27.1 2.9 28 4 28H20C21.1 28 22 27.1 22 26V14C22 12.9 21.1 12 20 12ZM20 26H4V16L12 21L20 16V26ZM12 19L4 14H20L12 19Z"
                        fill="black"
                        fillOpacity="0.38"
                      />
                      <rect
                        x="16"
                        width="19"
                        height="20"
                        rx="9.5"
                        fill="#FF9800"
                      />
                      <path
                        d="M23.8711 12.8867H23.9883C24.5273 12.8867 24.9766 12.8164 25.3359 12.6758C25.6992 12.5312 25.9883 12.332 26.2031 12.0781C26.418 11.8242 26.5723 11.5254 26.666 11.1816C26.7598 10.8379 26.8066 10.4648 26.8066 10.0625V8.5918C26.8066 8.24414 26.7695 7.93945 26.6953 7.67773C26.625 7.41211 26.5234 7.19141 26.3906 7.01562C26.2617 6.83594 26.1113 6.70117 25.9395 6.61133C25.7715 6.52148 25.5898 6.47656 25.3945 6.47656C25.1797 6.47656 24.9863 6.52539 24.8145 6.62305C24.6465 6.7168 24.5039 6.84766 24.3867 7.01562C24.2734 7.17969 24.1855 7.37305 24.123 7.5957C24.0645 7.81445 24.0352 8.04883 24.0352 8.29883C24.0352 8.5332 24.0625 8.75977 24.1172 8.97852C24.1758 9.19336 24.2617 9.38477 24.375 9.55273C24.4883 9.7207 24.6309 9.85352 24.8027 9.95117C24.9746 10.0488 25.1758 10.0977 25.4062 10.0977C25.625 10.0977 25.8262 10.0566 26.0098 9.97461C26.1934 9.88867 26.3535 9.77344 26.4902 9.62891C26.627 9.48438 26.7344 9.32227 26.8125 9.14258C26.8906 8.96289 26.9336 8.7793 26.9414 8.5918L27.4805 8.75586C27.4805 9.05273 27.418 9.3457 27.293 9.63477C27.1719 9.91992 27.002 10.1816 26.7832 10.4199C26.5684 10.6543 26.3164 10.8418 26.0273 10.9824C25.7422 11.123 25.4316 11.1934 25.0957 11.1934C24.6895 11.1934 24.3301 11.1172 24.0176 10.9648C23.709 10.8086 23.4512 10.5977 23.2441 10.332C23.041 10.0664 22.8887 9.76172 22.7871 9.41797C22.6855 9.07422 22.6348 8.71289 22.6348 8.33398C22.6348 7.92383 22.6973 7.53906 22.8223 7.17969C22.9473 6.82031 23.1289 6.50391 23.3672 6.23047C23.6055 5.95312 23.8945 5.73828 24.2344 5.58594C24.5781 5.42969 24.9668 5.35156 25.4004 5.35156C25.8613 5.35156 26.2656 5.44141 26.6133 5.62109C26.9609 5.80078 27.2539 6.04883 27.4922 6.36523C27.7305 6.68164 27.9102 7.04883 28.0312 7.4668C28.1523 7.88477 28.2129 8.33398 28.2129 8.81445V9.3125C28.2129 9.81641 28.168 10.3027 28.0781 10.7715C27.9883 11.2363 27.8418 11.668 27.6387 12.0664C27.4395 12.4609 27.1758 12.8086 26.8477 13.1094C26.5234 13.4062 26.125 13.6387 25.6523 13.8066C25.1836 13.9707 24.6328 14.0527 24 14.0527H23.8711V12.8867Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
